<template>
    <div class="baseInfo">
        <div class="manage-main">
            <div class="rule" style="display: flex;background: #fff;">
                <Menu></Menu>
                <div class="manage-right">
                    <div class="manage-right-in">
                        <div class="right-top">
                        <div class="right-title">基础信息</div>
                        <div class="baseInfo-table">
                            <p>
                                <span class="name">企业名称</span>
                                <span>{{BaseList.Customer}}</span>
                            </p>
                            <p>
                                <span class="name">企业编号</span>
                                <span>{{BaseList.CustomerNO}}</span>
                            </p>

                        </div>

                        
                        </div>
                    </div>
                    <div class="manage-right-in">
                        <div class="right-top">
                        <div class="right-title">财务信息</div>
                        <div class="baseInfo-table">
                            <p>
                                <span class="name">交易币种</span>
                                <span>{{BaseList.Currency}}</span>
                            </p>
                            <p>
                                <span class="name">结算方式</span>
                                <span>{{BaseList.Settlement==1?'单单清':BaseList.Settlement==2?'周结':BaseList.Settlement==3?'半月结':BaseList.Settlement==4?'月结':BaseList.Settlement==5?'季度结':BaseList.Settlement==6?'VCC':BaseList.Settlement==7?'预付结算':''}}</span>
                            </p>
                            <p v-if="BaseList.Settlement==7">
                                <span class="name">预付款余额</span>
                                <span>{{BaseList.PrepayAmount?BaseList.PrepayAmount:0}}
                                    <span>
                                        <span class="CreditBtn" @click="goReceiptsNew">使用记录></span>
                                        <span class="CreditBtn" @click="goCharge">充值记录></span>
                                    </span>
                                </span>
                            </p>
                            <p v-else>
                                <span class="name">信贷额度</span>
                                <span>{{BaseList.TotalCredits?BaseList.TotalCredits:0}}</span>
                            </p>
                            <p v-if="BaseList.Settlement!=7">
                                <span class="name">已用额度</span>
                                <span>{{BaseList.UsedCredits?BaseList.UsedCredits:0}}</span>
                            </p>

                        </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from './../../common/cmpnt/menu/Menu'

    export default {
        name: "BasicsInfo",
        components: {
            Menu
        },
        data: function () {
            return {
                BaseList: '',
                userInfo: this.dao.get('userInfo')
            }
        },

        mounted() {
            this.initData();
            document.title='基础信息---云境';
        },
        methods: {
            goReceipts(){
                let routeData= this.$router.resolve({
                    path: '/receiptsBill/'
                })
                window.open(routeData.href, '_blank')
            },
            goReceiptsNew(){
                let routeData= this.$router.resolve({
                    path: '/receiptsBillNew/'
                })
                window.open(routeData.href, '_blank')
            },
            goCharge(){
                let routeData= this.$router.resolve({
                    path: '/chargeBill/'
                })
                window.open(routeData.href, '_blank')
            },
            initData() {
                var that = this;
                that.getRequest({
                    url: that.Api.getAccount,
                    params: ''
                }).then(res => {
                    if (res.IsSuccess) {
                        that.BaseList = res.Result
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }     
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
.CreditBtn {
    vertical-align: middle;
    float: right;
    color: #1270f8;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
}
/* 定义一个类，用于应用样式 */
.label-new {
  position: relative;
  display: inline-block;
  margin-left: 20px; /* 确保文本和标记之间有间距 */
}

.label-new::after {
  content: '新';
  position: absolute;
  top: 50%;
  left: 0px; /* 标记距离文本的距离 */
  background-color: #dd2525;
  color: white;
  font-size: 12px;
  line-height: 20px; /* 设置行高与标记高度相同，实现垂直居中 */
  height: 20px; /* 设置标记的高度 */
  width: 20px; /* 设置标记的宽度 */
  text-align: center; /* 水平居中对齐文本 */
  border-radius: 3px;
  padding: 0; /* 移除内边距，因为我们已经通过 line-height 实现了垂直居中 */
  transform: translateY(-50%); /* 使用变换将标记向上移动50%，实现垂直居中 */

}
</style>



// WEBPACK FOOTER //
// src/components/account/BaseInfo.vue